import { useMemo } from 'react';
import * as R from 'remeda';
import { Chip, Stack, Tooltip } from '@rossum/ui/material';
import { Url } from '../../../../../../types/basic';
import { WorkspaceWithQueues } from '../../../../../../types/workspace';
import { ExtensionText, ExtensionTextWithTooltip } from './ExtensionText';

type Props = {
  queueUrls: Array<Url>;
  workspaces: Array<WorkspaceWithQueues>;
  id: string | number;
};

// This component is weird and should be refactored
export const ExpandableWorkspaceBadges = ({
  queueUrls = [],
  workspaces,
  id,
}: Props) => {
  const queues = useMemo(() => {
    const flattenQueues = workspaces.flatMap(workspace => workspace.queues);

    return flattenQueues.filter(({ url }) => queueUrls.includes(url));
  }, [workspaces, queueUrls]);

  const workspacesWithQueues = R.groupBy(
    queues,
    queue => queue.workspace ?? undefined
  );
  const [firstItem, ...restOfItems] = Object.keys(workspacesWithQueues);

  if (!firstItem) {
    return null;
  }

  const findWorkspace = (url: string) =>
    workspaces.find(_workspace => _workspace.url === url)?.name || 'N/A';

  return (
    <Stack
      direction="row"
      alignItems="center"
      px={1}
      spacing={1}
      sx={{ maxWidth: 'calc(100% - 24px)' }}
    >
      <Chip
        label={
          <ExtensionTextWithTooltip
            secondaryText={findWorkspace(firstItem)}
            primaryText={
              workspacesWithQueues[firstItem]
                ?.map(item => item.name)
                .join(',') ?? 'N/A'
            }
          />
        }
        sx={{ minWidth: 0 }}
      />
      {!!restOfItems.length && (
        <Tooltip
          placement="top"
          disableInteractive
          title={restOfItems.map(workspace => {
            const queueNames =
              workspacesWithQueues[workspace]
                ?.map(item => item.name)
                .join(',') ?? 'N/A';

            return (
              <ExtensionText
                key={`${workspace}-${id}`}
                primaryText={queueNames}
                secondaryText={findWorkspace(workspace)}
              />
            );
          })}
        >
          <Chip label={`+${restOfItems.length}`} />
        </Tooltip>
      )}
    </Stack>
  );
};
